import { AppError } from "../../../shared/utils/error-handler";
import type { CompanyStatisticsRepository } from "../../repositories/company/company-statistics-repository";
import type {
  OrderAmountSummaryQuery,
  OrderAmountSummaryResponse,
  RegistrationStatsResponse,
  VisitorStatsResponse,
  OrderStatsResponse,
  PaymentStatsResponse,
} from "../../types/company/company-statistics";

export class CompanyStatisticsUseCase {
  constructor(
    private companyStatisticsRepository: CompanyStatisticsRepository,
  ) {}

  getOrderAmountSummary(companyId: number, query: OrderAmountSummaryQuery): Promise<OrderAmountSummaryResponse> {
    return this.companyStatisticsRepository.getOrderAmountSummary(companyId, query);
  }

  async getRegistrationStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<RegistrationStatsResponse> {
    try {
      return await this.companyStatisticsRepository.getRegistrationStats(
        companyId,
        period,
        startDate,
        endDate,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "가입자수 통계를 조회하지 못했습니다.",
        "REGISTRATION_STATS_GET_FAILED",
        error,
      );
    }
  }

  async getVisitorStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<VisitorStatsResponse> {
    try {
      return await this.companyStatisticsRepository.getVisitorStats(
        companyId,
        period,
        startDate,
        endDate,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "방문자수 통계를 조회하지 못했습니다.",
        "VISITOR_STATS_GET_FAILED",
        error,
      );
    }
  }

  async getOrderStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<OrderStatsResponse> {
    try {
      return await this.companyStatisticsRepository.getOrderStats(
        companyId,
        period,
        startDate,
        endDate,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "주문량 통계를 조회하지 못했습니다.",
        "ORDER_STATS_GET_FAILED",
        error,
      );
    }
  }

  async getPaymentStats(
    companyId: number,
    period: string,
    startDate: string,
    endDate: string,
  ): Promise<PaymentStatsResponse> {
    try {
      return await this.companyStatisticsRepository.getPaymentStats(
        companyId,
        period,
        startDate,
        endDate,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "결제금액 통계를 조회하지 못했습니다.",
        "PAYMENT_STATS_GET_FAILED",
        error,
      );
    }
  }
}

